document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("upsell-form");
  if (!form) return;

  const checkboxes = form.querySelectorAll(".upsell-item-checkbox");
  const totalPriceEl = document.getElementById("upsell-total-price");
  const submitBtn = document.getElementById("upsell-submit-btn");

  function formatMoney(cents) {
    const dollars = cents / 100;
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(dollars);
  }

  function calculateTotal() {
    let totalCents = 0;
    let checkedCount = 0;

    checkboxes.forEach((checkbox) => {
      const cardCheckbox = "product-item-" + checkbox.value
      const cardCheckboxID = document.getElementById(cardCheckbox)

      console.log(cardCheckboxID)
      if (checkbox.checked) {
        totalCents += parseInt(checkbox.getAttribute("data-price"), 10);
        checkedCount++;
        cardCheckboxID.classList.add("upsell-checked");
      } else {
        cardCheckboxID.classList.remove("upsell-checked");
      }
    });

    // Update UI elements
    totalPriceEl.textContent = formatMoney(totalCents);
    
    // Enable or disable main button based on selection status
    if (checkedCount > 0) {
      submitBtn.removeAttribute("disabled");
      submitBtn.innerText = `Add Selected (${checkedCount}) to Cart`;
    } else {
      submitBtn.setAttribute("disabled", "true");
      submitBtn.innerText = "No items selected";
    }
  }

  // Listen for user interactions
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", calculateTotal);
  });
});